// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1sCZu","header":"ReportDetails_header__3WQDC","title":"ReportDetails_title__At-aS","left":"ReportDetails_left__l_mYR"};